import React, { Component } from "react";
import PropTypes from "prop-types";
import icon from "../images/icone-confirmed.png";
import icon_info from "../images/icone-search-document.png";
import RedirectAuthenticate from "../components/RedirectAuthenticate.js";
export class ValidationConfirmed extends Component {
  render() {
    return (
      <div className="container h-100" style={{ overflowX: "hidden" }}>
        <div className="row text-center px-4 mt-5" style={{ minHeight: "calc(100vh - 106px)" }}>
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 mt-5 ">
            {this.props.registryOk && (
              <>
                <img src={icon} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">VALIDAÇÃO CONFIRMADA</h1>
                <h5 className="card-text text-light">Agora você já pode assinar o seu documento</h5>
              </>
            )}
            {this.props.faceOk && (
              <>
                <img src={icon_info} style={{ maxHeight: "125px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">CARREGANDO DOCUMENTO</h1>
                <div className="row mt-5 justify-content-center">
                  <div className="col-12 d-grid">
                    <main className="position-relative">
                      <div className="loading-bar-container ">
                        <div className=" loading-bar-container loading-bar" />
                      </div>
                      <h5 className="position-absolute start-50 translate-middle mt-4">Aguarde...</h5>
                    </main>
                  </div>
                </div>
              </>
            )}
            {this.props.authentication && (
              <>
                <img src={icon} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
                <h1 className="card-title fw-bold text-white mt-5">AUTENTICAÇÃO CONFIRMADA</h1>
                {this.props.urlRedirect ? <RedirectAuthenticate urlRedirect={this.props.urlRedirect} /> : window.opener ? this.verifyPopUp() : ""}
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
  verifyPopUp() {
    window.opener.postMessage([true, this.props.keyCallback], "*");
    window.close();
  }
}

ValidationConfirmed.propTypes = {
  registryOk: PropTypes.bool,
  faceOk: PropTypes.bool,
  authentication: PropTypes.bool,
  urlRedirect: PropTypes.string,
  keyCallback: PropTypes.string,
};

export default ValidationConfirmed;
